import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { environment } from '../../environments/environment.prod';
import { GoogleApiIntegrationService } from '../google-api-integration.service';
import * as $ from 'jquery';
import { stringify } from '@angular/compiler/src/util';

@Component({
  selector: 'flow-budget-insurance',
  templateUrl: './flow-budget-insurance.component.html',
  styleUrls: ['./flow-budget-insurance.component.css']
})
export class FlowBudgetInsuranceComponent implements OnInit {

  // API_URL = environment.apiUrl_budget;
  API_URL = "http://insurecover.co.za/luhambo-leads-management/budget-lead-submitter.php";
  OFFER_ID: string = "377";
  AFF_ID: string = "14219";
  AFFILIATE_SHORT_CODE: string = "JMAFFSite103456";
  PRODUCT: string = "JMCar";

  success: boolean = false
  budgetInsuranceForm: FormGroup;
  errorCount: number;
  agentData: any;
  productData: any;
  validationMessages: any;
  formStatus: any = {
    formErrors: {},
    submitClicked: false
  };


  constructor(private formBuilder: FormBuilder, private googleApiIntegrationService: GoogleApiIntegrationService) {
    this.productData = {
      name: 'product',
      label: 'Product:',
      options: [
        {name: 'vehicleInsurance', label: 'Vehicle Insurance'}, 
        {name: 'homeInsurance', label: 'Home Insurance'}],
      placeholder: 'Select Product'
    };
    
    this.agentData = {
      name: 'agentName',
      label: 'Agent Name:',
      options: [],
      placeholder: 'Select Name'
    };
  }

  ngOnInit() {
    this.createForm();
    this.budgetInsuranceForm.get('product').disable();
    this.budgetInsuranceForm.get('tnc').disable();

    this.googleApiIntegrationService.readNames();
    this.googleApiIntegrationService.names.subscribe((names) => {
      let namesArray = JSON.parse(names);
      namesArray.map((nameArray, index) => {
        this.agentData.options[index] = {name: 'agent-' + index, label: nameArray[0]};
      });
    });
  }

  createForm() {
    this.budgetInsuranceForm = this.formBuilder.group({
      name: ['', Validators.required],
      surname: ['', Validators.required],
      telephone: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      tnc: [true, Validators.required],
      agentName: '',
      product: 'Vehicle Insurance'
    });

    this.validationMessages = {
      name: {
        'required': 'Please enter a valid name'
      },
      surname: {
        'required': 'Please enter a valid surnname'
      },
      telephone: {
        'required': 'Please enter a valid number',
        'maxlength': 'Please enter a number not greater than 10 charaters',
        'minlength': 'Please enter a number not less than 10 charaters'
      },
      tnc: {
        'required': 'Please check if the customer has accepted the terms & conditions'
      }
    }

    this.formStatus['formErrors'] = {
      name: '',
      surname: '',
      telephone: '',
      tnc: '',
      product: ''
    }

    this.budgetInsuranceForm.valueChanges.subscribe((data) => {
      this.formIsValid();
    })
  }

  formIsValid() {
    if (!this.budgetInsuranceForm) {
      return;
    }

    const form = this.budgetInsuranceForm;
    this.errorCount = 0;

    // tslint:disable-next-line:forin
    for (const field in this.formStatus['formErrors']) {
      // clear previous error message (if any)
      this.formStatus['formErrors'][field] = '';
      const control = form.get(field);

      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[field];
        
        for (const key in control.errors) {
          this.formStatus['formErrors'][field] += messages[key] + ' ';
          this.errorCount++;
        }

      }
    }
  }

  submitLead() {
    if (this.budgetInsuranceForm.status !== 'VALID') {
      this.formStatus.submitClicked = true;
      this.formIsValid();
      return;
    }

    let name = this.budgetInsuranceForm.controls['name'].value;
    let surname = this.budgetInsuranceForm.controls['surname'].value;
    let telephone = this.budgetInsuranceForm.controls['telephone'].value;
    let agentName = this.budgetInsuranceForm.controls['agentName'].value;
    let tnc = this.budgetInsuranceForm.get('tnc').value;
    let product = this.budgetInsuranceForm.get('product').value;

    this.success = true;
    $.post(this.API_URL, {
      AffiliateShortCode: this.AFFILIATE_SHORT_CODE,
      FirstName: name,
      LastName: surname,
      CellNumber: telephone,
      AcceptTerms: tnc,
      Offer_Id: this.OFFER_ID,
      Aff_Id: this.AFF_ID,
      Product: this.PRODUCT
    }, (response, status) => {
      let resp = JSON.parse(response);
      console.log(resp);

      if (status === "success") {
        this.success = true;
        this.googleApiIntegrationService.writeToBudgetSheet({
          firstName: name,
          surname: surname,
          phone: telephone,
          product: product,
          agentName: agentName.label,
          status: resp.response,
          reason: resp.payout
        });
      } else {
        if (status === "error") {

          this.googleApiIntegrationService.writeToBudgetSheet({
            firstName: name,
            surname: surname,
            phone: telephone,
            product: product.label,
            agentName: agentName.label,
            status: resp.response,
            reason: resp.payout
          });
        }
      }
    }, "json");
  }

  resetForm() {
    this.budgetInsuranceForm.reset();
    this.success = false;
  }

}
